/** TinyMCE iframe 등 document click 으로 닫히지 않는 영역 포커스 시 Select/DatePicker 드롭다운 일괄 닫기 */
export const UI_OVERLAY_DISMISS_EVENT = 'ui-overlay-dismiss';

export const dismissOpenOverlays = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(UI_OVERLAY_DISMISS_EVENT));
};
